import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { useNavigate } from 'react-router'
import { getDocumentsUrlWithCurrentParams } from '~/entities/document'
import { apiClient } from '~/shared/api/data-ingestion-api'
import { useSubmitPatientMatch } from '../api'

export function useSubmitPatientMatchingReview({ documentKey }: { documentKey: string }) {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const onSuccess = useCallback(() => {
    queryClient.invalidateQueries(
      apiClient.getDocumentDocumentsKeyGetOptions({
        path: { key: documentKey },
      }),
    )
    navigate(getDocumentsUrlWithCurrentParams())
  }, [documentKey, navigate, queryClient])

  const {
    mutateAsync: addPatientMatchingReview,
    isError,
    isPending,
  } = useSubmitPatientMatch({
    onSuccess,
  })

  const submitPatientMatchingReview = useCallback(
    async (patientMatchingReview: apiClient.PatientCaseMatchingFeedbackRequest) => {
      await addPatientMatchingReview({
        path: { key: documentKey },
        body: patientMatchingReview,
      })
    },
    [addPatientMatchingReview, documentKey],
  )

  return {
    submitPatientMatchingReview,
    isPatientMatchingReviewError: isError,
    isPatientMatchingReviewPending: isPending,
  }
}
